<template>
    <span
        :title="title"
        class="badge px-3 py-1 m-0"
        :class="getDNXColor(value ?? '')"
        v-if="value"
        >{{ computedValue }}</span
    >
</template>

<script lang="ts" setup>
import { $tm } from '@/locize';
import type { ExitStatus, TimeExitStatus } from '@/objects/generated';
import { computed } from 'vue';

const props = defineProps<{
    value?: ExitStatus | TimeExitStatus | null;

    title?: string;
}>();

/**
 * Computed value for the display of the DNX status
 */
const computedValue = computed(() => {
    return props.value == 'Finished' ? $tm('exitstatus.finished') : props.value;
});

const getDNXColor = (value: ExitStatus | TimeExitStatus): string => {
    if (!value) {
        return '';
    }

    if (value == 'DNS') {
        return 'bg-warning border border-warning text-dark';
    } else if (value == 'DNF') {
        return 'bg-danger text-white border border-danger';
    } else if (value == 'DSQ') {
        return 'bg-info text-white border border-info';
    } else if (value == 'Finished') {
        return 'bg-primary text-white border border-primary';
    } else {
        return '';
    }
};
</script>
